import { render, staticRenderFns } from "./BarcodeOrderInventoryLinking.vue?vue&type=template&id=1265c9d4"
import script from "./BarcodeOrderInventoryLinking.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderInventoryLinking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports